import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineMail,
} from "react-icons/ai";
import jwt_decode from "jwt-decode";
import leftsideimage from "../Logins/assets/leftsideimage.PNG";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../Context/AuthContext";
import { Userlogin } from "../../Redux/auth/action";
import { getUsers } from "../../Redux/app/action";

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const token = useSelector((store) => store.authentication.data.token.token);
  const globalState = useSelector((store) => store.authentication.data.token);
  const isAuth = useSelector((store) => store.authentication.data.isAuth);
  const extra = useSelector((store) => store.authentication.data.extra);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);

  const [usercred, setUserCred] = useState({});

  const toast = useToast();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserCred({
      ...usercred,
      [name]: value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    await dispatch(Userlogin(usercred));
    setLoading(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    if (token) {
      if (globalState.role.toLowerCase() === "admin") {
        navigate("/admin");
        toast({
          position: "top",
          title: `Welcome Back ${globalState.sudo_name}`,
          description: "Successfully Logged In",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          position: "top",
          title: "Warning",
          description: "Check the correct routes of credentials",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
      }
    } else if (extra === "extraAuth" && !isAuth) {
      toast({
        position: "top",
        title: "Invalid Credentials",
        description: "Enter the correct credentials",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [
    token,
    globalState.role,
    globalState.sudo_name,
    navigate,
    toast,
    extra,
    isAuth,
  ]);

  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => setShowPassword(!showPassword);

  return (
    <>
      <Flex flexWrap="wrap" justifyContent="center">
        <Box p={{ base: "none", md: 10 }} bg={"white"}>
          <Image
            p={{ base: "none", md: 10 }}
            width={{ base: "100%", sm: "45%", md: "80%" }}
            src={leftsideimage}
          />
        </Box>

        <Box
          p={20}
          bg={"white"}
          width={{ base: "100%", sm: "45%", md: "40%" }}
          alignItems={"center"}
          alignSelf={"center"}
        >
          <form onSubmit={handleLogin}>
            <FormControl>
              <Text fontSize="3xl" fontWeight={"bold"} textAlign={"start"}>
                SIGN IN TO ADMIN E&D 360
              </Text>
              <br />
              <br />
              <Flex flexWrap="wrap" justifyContent="space-between">
                <Button
                  onClick={() => navigate("/")}
                  textColor={"white"}
                  background={"#00ab55"}
                  _hover={{ textColor: "white", background: "#00ab55" }}
                >
                  User Login
                </Button>
                <Button
                  onClick={() => navigate("/companyLogin")}
                  textColor={"white"}
                  background={"#00ab55"}
                  _hover={{ textColor: "white", background: "#00ab55" }}
                >
                  Company Login
                </Button>
              </Flex>
              <br />
              <br />
              <Flex alignItems="center">
                <Box
                  flex="1"
                  borderBottom="1px solid"
                  borderColor="gray.400"
                  mr="4"
                />
                <Text
                  fontWeight="medium"
                  textTransform="uppercase"
                  textColor={"gray"}
                >
                  OR
                </Text>
                <Box
                  flex="1"
                  borderBottom="1px solid"
                  borderColor="gray.400"
                  ml="4"
                />
              </Flex>
              <br />
              <FormLabel>Admin Id </FormLabel>
              <InputGroup>
                <Input
                  type="text"
                  id="employee_id"
                  name="employee_id"
                  placeholder="Enter Admin Id"
                  onChange={handleChange}
                  required
                  onKeyPress={handleKeyPress}
                />
                <InputRightElement
                  style={{ background: "#00ab55" }}
                  pointerEvents="none"
                  children={<AiOutlineMail color="white" />}
                />
              </InputGroup>
              <br />
              <FormLabel>Password</FormLabel>
              <InputGroup>
                <Input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Admin Password"
                  onChange={handleChange}
                  required
                  onKeyPress={handleKeyPress}
                />
                <InputRightElement width="4.5rem">
                  <IconButton
                    h="1.75rem"
                    size="sm"
                    onClick={togglePassword}
                    icon={
                      showPassword ? (
                        <AiOutlineEyeInvisible />
                      ) : (
                        <AiOutlineEye />
                      )
                    }
                    aria-label="Toggle Password"
                    variant="ghost"
                  />
                </InputRightElement>
              </InputGroup>
              <br />
              <Button
                type="submit"
                w={"full"}
                textColor={"white"}
                background={"#00ab55"}
                _hover={{ textColor: "white", background: "#00ab55" }}
                isLoading={loading}
              >
                Login Now
              </Button>
            </FormControl>
          </form>
        </Box>
      </Flex>
    </>
  );
};

export default AdminLogin;
